import { render } from "./Messages.vue?vue&type=template&id=b17d0fc6"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Messages.vue?vue&type=style&index=0&id=b17d0fc6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__